var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIntermodal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 84.861V30.577h6.044v2.05h82.02v-2.05H100V84.86h-5.936V82.92h-82.02v1.942H6zM18.195 38.455v38.312M29.851 38.455v38.312M41.506 38.455v38.312M53.162 38.455v38.312M64.818 38.455v38.312M76.473 38.455v38.312M88.128 38.455v38.312M6 30.468L14.094 20h4.101v2.374h70.15V20h3.669L100 30.468",
    stroke: "#2E5ECC",
    strokeWidth: 3
  })));
}

export default SvgIntermodal;